// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3585":"9fd9c01a","8831":"b28a5ece"}[chunkId] + ".chunk.css";
};